import type { TaxRebate } from '../../types/tax';

export const TAX_REBATES_2024_25: TaxRebate = {
  primary: 17235, // Primary rebate for all taxpayers
  secondary: 9444, // Additional rebate for people 65 and older  
  tertiary: 3145,  // Additional rebate for people 75 and older
};